
//const fab = require('../components/fab/fab')



export function start(ev){    //console.log('shortCuts EXTERNAL :)>', ev)

    if(ev.altKey != true){
        return
    }


    if(ev.key === '+'){
        //fab.start({act:'add'})
    }



}





/*

alt '+' + > add a new element
alt '+' s > search
alt '+' u > click the user avatar


move on the fullcont pages
move on the left menu
move on the table by the arrow
move by the menu

select an object by arrows





*/